// Every metric is defined once here, and the same words appear on the
// transparency page. Never change a definition quietly: add a new key.

export const METRICS = {
  downloads: "Verified people who started an ISO download. Internal accounts are excluded.",
  installs: "Unique devices that sent install.first_boot, by day and channel.",
  active_7d: "Devices with a heartbeat in the last 7 days.",
  active_30d: "Devices with a heartbeat in the last 30 days.",
  silent: "Devices seen before but with no heartbeat for more than 30 days. Kept as their own state.",
  update_success: "update.apply_ok divided by update.apply_start, per release.",
  rollback_rate: "update.rollback divided by update.apply_ok, per release.",
  crash_free: "Active devices with zero crash events in 7 days, divided by active devices.",
  activation_rate: "Activated devices divided by first boots, 30-day cohort.",
  feedback_closure: "Median days from feedback created to status answered.",
} as const;

export const METHODOLOGY =
  "Devices without telemetry consent are not counted, so every device number is a floor. " +
  "A reinstall keeps its ID; only a factory reset creates a new one. Server receive time is used for all dates.";
